/** Admin guide §3 — Teams (`admin/TeamsTab.tsx`, Settings → Teams). */
import { helpSectionMeta } from '../help-sections.js';
import {
  Btn,
  Bullets,
  Callout,
  HelpSectionCard,
  Li,
  P,
  SectionLink,
  Shot,
  SubHead,
} from '../HelpPrimitives.js';

export function AdminTeams(): React.JSX.Element {
  return (
    <HelpSectionCard meta={helpSectionMeta('admin-teams')}>
      <Shot
        slug="admin-teams"
        caption="Recruiter team cards, each showing its team lead and members."
      />
      <P>
        Recruiter teams — not to be confused with{' '}
        <SectionLink to="admin-sourcing-teams">Sourcing Teams</SectionLink>. Click{' '}
        <Btn>Add team</Btn> to create one.
      </P>

      <SubHead>The team dialog</SubHead>
      <Bullets>
        <Li>
          <Btn>Team Name</Btn> is required.
        </Li>
        <Li>
          <Btn>Team Lead</Btn> — pick from a dropdown of every user.
        </Li>
        <Li>
          Members are shown here read-only; assign a user to the team from the{' '}
          <SectionLink to="admin-users">Users</SectionLink> tab instead.
        </Li>
      </Bullets>

      <Callout title="Delete here is permanent">
        <P>
          Unlike Sourcing Teams, deleting a team card removes it outright, with no confirmation
          step.
        </P>
      </Callout>
    </HelpSectionCard>
  );
}
